import ContractRangeParameter from '@/domain/contract/entity/contract-range-parameter.entity';
import FilterUtils from '@/shared/utils/filters';

export default class RuleScriptParameter {
  index: number;

  id: string;

  name: string;

  description: string;

  label: string;

  type: any;

  value: any;

  rangeLength: number = 2;

  constructor(obj: any = {}) {
    this.index = obj.index;
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.label = obj.label || '';
    this.type = obj.type || '';
    this.value = obj.value || '';
  }

  public static of(obj: any = {}): RuleScriptParameter {
    return new RuleScriptParameter(obj);
  }

  public static ofList(obj: any[] = []): RuleScriptParameter[] {
    return obj.map(this.of);
  }

  get isMoneyInput(): boolean {
    return this.type.value === 'MONEY';
  }

  get isMoney2Input(): boolean {
    return this.type.value === 'MONEY2';
  }

  get isPercentInput(): boolean {
    return this.type.value === 'PERCENT';
  }

  get isPercent2Input(): boolean {
    return this.type.value === 'PERCENT2';
  }

  get isLongInput(): boolean {
    return this.type.value === 'LONG';
  }

  get isRangeInput(): boolean {
    return this.type.value === 'RANGE';
  }

  get isRange2Input(): boolean {
    return this.type.value === 'RANGE2';
  }

  get isStringListInput(): boolean {
    return this.type.value === 'STRING_LIST';
  }

  get isKeyValueInput(): boolean {
    return this.type.value === 'KEY_VALUE';
  }

  get isKeyValuePercentInput(): boolean {
    return this.type.value === 'KEY_VALUE_PERCENT';
  }

  get isRangePercentInput(): boolean {
    return this.type.value === 'RANGE_PERCENT';
  }

  get isRangePercent2Input(): boolean {
    return this.type.value === 'RANGE_PERCENT2';
  }

  get isBooleanInput(): boolean {
    return this.type.value === 'BOOLEAN';
  }

  get isCurrency(): boolean {
    return this.type.value === 'CURRENCY_CONVERT';
  }

  get isSeniority(): boolean {
    return this.type === 'STRING_LIST_SENIORITY';
  }

  addStringValue(value: string) {
    if (value) {
      this.value.push(value)
    }
  }

  addCurrencyConvertValue(value: string) {
    this.value[0] = value;
  }

  handleValueParameter(): any {
    if (this.isRangeInput || this.isRange2Input || this.isRangePercentInput
      || this.isRangePercent2Input) {
      this.addGenericRanges(this.rangeLength)
    } else if (this.isStringListInput) {
      this.value = [];
    } else {
      this.value = 0;
    }
  }

  addGenericRanges(numberOfRanges: number) {
    this.value = [];
    const times: number = numberOfRanges;
    for (let i: number = 0; i < times; i += 1) {
      if (i + 1 === times) {
        this.value.push(new ContractRangeParameter(this.genericLastRange));
      } else {
        this.value.push(new ContractRangeParameter(this.genericRange));
      }
    }
  }

  updateValueArray(): void {
    if (this.rangeLength > this.value.length) {
      const times: number = this.rangeLength - this.value.length;
      for (let i: number = 0; i < times; i += 1) {
        this.value.push(new ContractRangeParameter(this.genericLastRange));
      }
    }
    if (this.rangeLength < this.value.length) {
      const times: number = this.value.length - this.rangeLength;
      for (let i: number = 0; i < times; i += 1) {
        if (this.rangeLength > 1) {
          this.value.pop();
        }
      }
    }
  }

  get valueSize() {
    return this.value.length;
  }

  isLastValue(index: number): boolean {
    return this.value.length === index + 1;
  }

  initialQuantity(index: number): any {
    if (index === 0) {
      return 1;
    }
    let previousQuantity = parseInt(this.value[index - 1].quantidade, 10);
    return previousQuantity += 1
  }

  finalQuantityType(index: number): string {
    return this.isLastValue(index) ? 'text' : 'number';
  }

  faixaName(index: number): string {
    const normalizedIndex: number = index + 1;
    if (normalizedIndex === 1) {
      return 'Faixa 1 - Inicial';
    }
    if (normalizedIndex === this.value.length) {
      return `Faixa ${normalizedIndex} - Final`;
    }
    return `Faixa ${normalizedIndex}`;
  }

  get genericRange(): any {
    return {
      quantidade: 0,
      valor: 0.0000,
    }
  }

  get genericLastRange(): any {
    return {
      quantidade: 'Infinito',
      valor: 0.0000,
    }
  }

  validateMoneyFormatValues() {
    if ((this.isRangeInput || this.isRange2Input)) {
      this.value.forEach((el: ContractRangeParameter, index: number) => {
        el.valor = FilterUtils.formatValue(el.valor);
      })
    }
    if (this.isMoneyInput || this.isMoney2Input || this.isPercentInput || this.isPercent2Input) {
      this.value = FilterUtils.formatValue(this.value);
    }
  }
}
